// ----------------------------------------------------------------------------
// Template: Pages
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import 'sections/header/header';
import 'sections/hero-banner/hero-banner';
import 'sections/intro-block/intro-block';
import 'sections/content-panel/content-panel';
import 'sections/content-cards/content-cards';
import 'sections/icon-block/icon-block';
import 'sections/veritree-stats/veritree-stats';
import 'sections/yotpo-rewards-products/yotpo-rewards-products';
import 'sections/banner/banner-block';
import 'sections/faqs/faqs';
import 'sections/tabs/tabs';
import 'sections/collection-list/collection-list';
import 'sections/featured-collection/featured-collection';
import 'sections/blog-posts/blog-posts';
import 'sections/newsletter/newsletter';
import 'sections/page-header/page-header';
import 'sections/main-blog/main-blog';
import 'sections/rich-text/rich-text';
import 'sections/video-banner/video-block';
import 'sections/featured-product/featured-product';
import 'sections/press-block/press-block';
import 'sections/feature-highlight/feature-highlight';
import 'sections/ingredients-grid/ingredients-grid';
import 'sections/timeline/timeline';
import 'sections/promo-banner/promo-banner';
import 'sections/footer/footer';
import 'sections/testimonial/testimonial';
import 'sections/long-panel/long-panel';
import 'sections/recipe-driver/recipe-driver';
import 'snippets/country-modal/country-modal';

import '../../sections/product/product';

// Styles
import './_pages.scss';
